import script from "./TemplateProgressTopNotification.vue?vue&type=script&setup=true&lang=ts"
export * from "./TemplateProgressTopNotification.vue?vue&type=script&setup=true&lang=ts"

import "./TemplateProgressTopNotification.vue?vue&type=style&index=0&id=4caeb011&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4caeb011"]])

export default __exports__